<div class="uli-card" [class.uli-card--disabled]="!userData.enabled" (click)="onUserClickEvent($event)">

  <!-- corner notch (top-right) -->
  <div class="uli-card__notch"></div>

  <!-- top accent bar -->
  <div class="uli-card__bar"></div>

  <!-- ── HEADER ── -->
  <div class="uli-card__header">

    <!-- avatar + status ring -->
    <div class="uli-avatar" [class.uli-avatar--online]="userData.enabled" [class.uli-avatar--offline]="!userData.enabled">
      <app-s3-image
        *ngIf="userData.avatarUrl; else avatarFallback"
        [isRounded]="true"
        [image]="userData.avatarUrl"
        class="uli-avatar__img"
      ></app-s3-image>
      <ng-template #avatarFallback>
        <div class="uli-avatar__fallback">
          <mat-icon>person</mat-icon>
        </div>
      </ng-template>
      <span class="uli-avatar__dot"></span>
    </div>

    <!-- name + roles -->
    <div class="uli-card__name-block">
      <div class="uli-card__username-row">
        <span class="uli-card__username" [title]="userData.username">{{ userData.username }}</span>
        <!-- status icon — neon colours visible on both themes -->
        <mat-icon *ngIf="userData.isEnabledField && userData.enabled"  class="uli-icon uli-icon--ok">check_box</mat-icon>
        <mat-icon *ngIf="userData.isEnabledField && !userData.enabled" class="uli-icon uli-icon--off">indeterminate_check_box</mat-icon>
      </div>

      <span *ngIf="userData.nickname" class="uli-card__nickname">{{ userData.nickname }}</span>

      <div *ngIf="userData?.roles?.length" class="uli-roles">
        <span class="uli-role-chip" *ngFor="let role of userData.roles">
          {{ role | replaceUnderscores: ' ' | lowercase }}
        </span>
      </div>
    </div>

    <!-- delete -->
    <button *ngIf="userData.canBeDeleted" class="uli-delete-btn" type="button"
            title="Remove agent" (click)="onDeleteEvent($event)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ── DIVIDER ── -->
  <div class="uli-card__divider"></div>

  <!-- ── INFO ── -->
  <div class="uli-card__info">
    <div *ngIf="userData.email" class="uli-info-item">
      <mat-icon class="uli-info-icon">alternate_email</mat-icon>
      <span class="uli-info-text" [title]="userData.email">{{ userData.email }}</span>
      <mat-icon *ngIf="userData.emailVerified" class="uli-verified-icon" title="Verified">verified</mat-icon>
    </div>

    <div *ngIf="userData.phone" class="uli-info-item">
      <mat-icon class="uli-info-icon">phone_iphone</mat-icon>
      <span class="uli-info-text" [title]="userData.phone">{{ userData.phone }}</span>
      <mat-icon *ngIf="userData.phoneVerified" class="uli-verified-icon" title="Verified">verified</mat-icon>
    </div>

    <div *ngIf="userData.teamName" class="uli-info-item">
      <mat-icon class="uli-info-icon">shield</mat-icon>
      <span class="uli-info-text" [title]="userData.teamName">{{ userData.teamName }}</span>
      <app-s3-image *ngIf="userData.teamImageUrl" [isRounded]="true"
                    [image]="userData.teamImageUrl" class="uli-team-img"></app-s3-image>
    </div>
  </div>

  <!-- scan-line + glow overlays (pointer-events: none) -->
  <div class="uli-card__scanlines"></div>
  <div class="uli-card__glow"></div>
</div>
